import { COUNTRY_CODES } from "../../constants/countries";

export const DASHBOARD_CONFIG = {
    [COUNTRY_CODES.ECUADOR]: {
        showAbonos: true,
        showHistoricoAbonos: true,
    },
    [COUNTRY_CODES.PARAGUAY]: {
        showAbonos: true,
        showHistoricoAbonos: true,
    },
    [COUNTRY_CODES.ELSALVADOR]: {
        showAbonos : false,
        showHistoricoAbonos : false
    }
};
export const getDashboardConfig = (pais) => { return DASHBOARD_CONFIG[pais] || DASHBOARD_CONFIG[COUNTRY_CODES.ECUADOR]; };